export class CreateSkillParams {
  createdBy: string;
  name: string;

  constructor(params: {createdBy: string; name: string}) {
    this.createdBy = params.createdBy;
    this.name = params.name;
  }
}

export class GetSkillsParams {
  page: number;
  size: number;
  search?: string;

  constructor(params: {page: number; size: number; search?: string}) {
    this.page = params.page;
    this.size = params.size;
    this.search = params.search;
  }
}
